// Application configuration

// API configuration
export const API_BASE_URL = 'http://localhost:8080/api';

// Storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'kya_banega_aaj_auth_token',
  USER_DATA: 'kya_banega_aaj_user_data',
  PREFERENCES: 'kya_banega_aaj_preferences'
};

// Default preferences
export const DEFAULT_PREFERENCES = {
  mealTypes: ['breakfast', 'lunch', 'dinner', 'snack'],
  dietaryType: ['vegetarian', 'non-vegetarian', 'vegan'],
  cuisinePreferences: ['indian', 'north-indian', 'south-indian', 'chinese', 'italian', 'thai']
};

// UI configuration
export const UI_CONFIG = {
  cardsPerPage: 6,
  paginationSize: 5,
  animationDuration: 300
};
